import { TFunction } from 'i18next';
import { Option } from 'components/interfaces/GeneralInterface';
import { SurfaceEnum } from 'submodules/api_middleware';

export const getMatchesState = (t: TFunction): Option[] => [
    {
        label: t('match.upcoming'),
        value: '0',
    },
    {
        label: t('match.active'),
        value: '1',
    },
    {
        label: t('match.planned'),
        value: '2',
    },
    {
        label: t('match.played'),
        value: '3',
    },
    {
        label: t('match.contumacy'),
        value: '4',
    },
    {
        label: t('match.postponed'),
        value: '5',
    },
    {
        label: t('match.not_started'),
        value: '6',
    },
];

export const getMatchesSurface = (t: TFunction): Option[] => [
    {
        label: t('MatchesPage.surface.grass'),
        value: SurfaceEnum.GRASS,
    },
    {
        label: t('MatchesPage.surface.umt'),
        value: SurfaceEnum.UMT,
    },
    {
        label: t('MatchesPage.surface.other'),
        value: SurfaceEnum.OTHER,
    },
    {
        label: t('MatchesPage.surface.not_set'),
        value: SurfaceEnum.NOT_SET,
    },
];
